module.exports = __webpack_public_path__ + "img/84e86e6.jpg";